export default function createArray(...args) {
  // Handlebars options object is always the last argument, so remove it
  const options = args.pop();
  return args;
}
